import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getListAsk } from "../../store/actions/ask";
import {
  getTemplatesAsk,
  deleteTemplateAsk
} from "../../store/actions/ask/templates";
import {
  remindSurveyAsk,
  changeViewedSurveyAsk
} from "../../store/actions/ask/surveys";
import { FormattedMessage } from "react-intl";
import { deleteDraftAsk } from "../../store/actions/ask/drafts";
import {
  displayErrorToast,
  displaySuccessToast
} from "../../store/actions/overflowNotification";
import List from "../../components/ask/list";
import Page from "../../components/general/page";

class AskListView extends Component {
  static propTypes = {
    accountantSelected: PropTypes.string,
    accountantUuidSelected: PropTypes.string,
    accountantIdSelected: PropTypes.string,
    clientIdSelected: PropTypes.string,
    company: PropTypes.object,
    companySelected: PropTypes.string,
    companyUuidSelected: PropTypes.string,
    deadlinesSubjectiveV2: PropTypes.object,    
    myType: PropTypes.string,
    pageRef: PropTypes.object
  };

  componentDidMount() {
    if (window.aptrinsic) {
      window.aptrinsic("track",
        this.props.myType === "STUDIO"
          ? "digital-box:ASK-LIST-STUDIO"
          : "digital-box:ASK-LIST-COMPANY");
    }
    if (this.props.myType === "STUDIO") {
      this.props.getListAsk(true, true);
      // this.props.getListDraftsAsk(this.props.auth, this.props.accountantIdSelected, this.props.clientIdSelected)
    } else {
      this.props.getTemplatesAsk();
      this.props.getListAsk(false);
    }
  }

  onDeleteTemplate(templateId) {
    this.props
      .deleteTemplateAsk(templateId)
      .then(res =>
        setTimeout(() => {
          this.props.getTemplatesAsk();
        }, 500));
  }

  render() {
    const { myType, pageRef } = this.props;
    return (
      <Page
        pageRef={pageRef}
        className="contentStructure transparent settings"
        title={<FormattedMessage id="ask.title" />}
        subtitle={
          myType !== "STUDIO" ? (
            <FormattedMessage id="ask.pages.list.subtitle" />
          ) : null
        }        
        text={<FormattedMessage id="ask.pages.list.goBack" />}
        pushUrl={"/"}
      >
        <List
          {...this.props}
          onDeleteTemplate={this.onDeleteTemplate.bind(this)}
        />
        {/* {myType === "STUDIO" ? <AccountantAskListPage {...this.props} onDeleteTemplate={this.onDeleteTemplate.bind(this)} /> : <ClientAskListPage {...this.props} /> } */}
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    accountantIdSelected: state.main.accountantIdSelected,
    accountantUuidSelected: state.main.accountantUuidSelected,
    accountantSelected: state.main.accountantSelected,
    company: state.company,
    companySelected: state.main.companySelected,
    companyUuidSelected: state.main.companyUuidSelected,
    clientIdSelected: state.main.clientIdSelected,
    surveys: state.ask.surveys,
    templates: state.ask.templates.list,
    drafts: state.ask.drafts,
    myType: state.main.myType
  };
}

const mapDispatchToProps = dispatch => ({
  getListAsk: (includeDrafts) =>
    dispatch(getListAsk(includeDrafts)),
  getTemplatesAsk: () =>
    dispatch(getTemplatesAsk()),
  /* getListDraftsAsk: (auth, accountantIdSelected, clientIdSelected) =>
    dispatch(getListDraftsAsk(auth, accountantIdSelected, clientIdSelected)),*/
  remindSurveyAsk: (surveyId) =>
    dispatch(remindSurveyAsk(surveyId)),
  deleteTemplateAsk: (templateId) =>
    dispatch(deleteTemplateAsk(templateId)),
  changeViewedSurveyAsk: (surveyId,
    viewed) =>
    dispatch(changeViewedSurveyAsk(surveyId,
      viewed)),
  deleteDraftAsk: (draftId) =>
    dispatch(deleteDraftAsk(draftId)),
  displayErrorToast: (message, title) =>
    dispatch(displayErrorToast(message, title)),
  displaySuccessToast: (message, title) =>
    dispatch(displaySuccessToast(message, title))
});

export default connect(mapStateToProps, mapDispatchToProps)(AskListView);
